// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3CVvn","top":"styles_top__3RQb_","left":"styles_left__1SUz7","description":"styles_description__2VVEM"};